import React, { useEffect, useRef, useState } from 'react';
import { Avatar, Typography } from 'components';
import jwt from 'jwt-decode';
import { RootState, useAppSelector } from 'store';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { UserRoleNames } from 'models/enums';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './index.scss';

export const AttendanceTrackingHeader = () => {
  const navigate = useNavigate();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const dropDownRef = useRef<HTMLDivElement>(null);
  const [isUserMenuVisible, setIsUserMenuVisible] = useState(false);

  const token: any = useAppSelector((state: RootState) => {
    return state.auth?.user?.authData?.token
      ? jwt(state.auth.user.authData.token)
      : '';
  });

  const userRole = useAppSelector(
    (state: RootState) => state.auth.user.authData?.data?.userRole
  );

  const roleLabel = userRole
    ? UserRoleNames[userRole as keyof typeof UserRoleNames] ?? userRole
    : '';

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (
        dropDownRef?.current &&
        buttonRef?.current &&
        !dropDownRef.current.contains(event.target as Node) &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsUserMenuVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="attendance-tracking-header">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Attendance Tracking</title>
      </Helmet>

      <div className="attendance-tracking-header__brand">
        <img
          src="/icons/aventude.svg"
          alt="Aventude Logo"
          onClick={() => navigate('/')}
        />
      </div>

      <Link to="/" className="attendance-tracking-header__portal-link">
        <ArrowBackIcon fontSize="small" />
        <span>Employee Portal</span>
      </Link>

      <div className="attendance-tracking-header__user">
        <Avatar name={token?.name} size="xsm" />
        <div className="attendance-tracking-header__user-info">
          <Typography
            text={token?.name}
            type="small_regular"
            weight="bold"
            className="attendance-tracking-header__user-name"
          />
          <Typography
            text={roleLabel}
            type="small_regular"
            className="attendance-tracking-header__user-role"
          />
        </div>

        <button
          ref={buttonRef}
          type="button"
          className={`attendance-tracking-header__user-btn ${
            isUserMenuVisible ? 'u-active' : ''
          }`}
          onClick={() => setIsUserMenuVisible(!isUserMenuVisible)}
          aria-label="User menu"
        >
          <img src="/icons/chevron-down.svg" alt="" />
        </button>

        {isUserMenuVisible && (
          <div className="attendance-tracking-header__user-menu" ref={dropDownRef}>
            <button onClick={() => navigate('/logout')} type="button">
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
